export default __webpack_public_path__ + "static/logo_home_mb-de842122c49284192eceff80e34030ad.png";